var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_306007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9195 7.43906C19.5996 6.99961 19.1039 6.75 18.5309 6.75H4.71797C4.01836 6.75 3.38203 7.18945 3.13699 7.84336L1.125 13.2117V3.375C1.125 2.75484 1.62984 2.25 2.25 2.25H6.38086C6.68141 2.25 6.96375 2.367 7.17645 2.57959L9.09492 4.5H15.75C16.3702 4.5 16.875 5.00484 16.875 5.625H18C18 4.38223 16.9928 3.375 15.75 3.375H9.5625L7.96992 1.78418C7.54805 1.36195 6.97852 1.125 6.38086 1.125H2.25C1.00723 1.125 0 2.13223 0 3.375V14.625C0 15.8678 1.00723 16.875 2.25 16.875H16.4215C17.1636 16.875 17.8112 16.3993 18.032 15.6906L20.1414 8.94059C20.3344 8.42344 20.243 7.875 19.9195 7.43906ZM19.0969 8.60625L16.9875 15.3562C16.9137 15.5918 16.6992 15.75 16.4215 15.75H2.25C2.13321 15.75 2.02651 15.7164 1.92048 15.6833C1.8437 15.6421 1.77602 15.5837 1.72375 15.5083C1.61719 15.3545 1.59356 15.1655 1.65948 14.9904L4.19073 8.24045C4.27148 8.02266 4.48242 7.875 4.71797 7.875H18.5625C18.7432 7.875 18.9086 7.9585 19.0157 8.10408C19.1215 8.25117 19.1531 8.43398 19.0969 8.60625Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_306007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.b313cb356e27c479dde666b92795a8aa.svg";
export { ForwardRef as ReactComponent };